import React, { useContext, useState } from 'react';
import { Box, Button, Card, CardContent, CardHeader, Stack, Typography } from '@mui/material';
import { translate as t } from 'hooks/useTranslations';
import { ChevronRight, ExpandLess, ExpandMore, Refresh } from '@mui/icons-material';
import { AppContext } from 'views/App/context';
import useDtbMetrics from '../_data_sources/useDtbMetrics';
import Loading from 'views/App/Portal/Loading';
import DtbItem from './DtbItem';

export default function DtbMetrics() {
  const { currentOrganizationId } = useContext(AppContext);
  const [showAll, setShowAll] = useState(false);
  const metricsQuery = useDtbMetrics(currentOrganizationId);

  // TODO: Restore action button when DTB view all page is available
  const cardHeaderAction = (
    <Button
      color='secondary'
      size='small'
      href='/admin/policy/dtb'
      endIcon={<ChevronRight />}
    >
      {t('dashboard.policy.dtbMetrics.viewAll')}
    </Button>
  );

  if (metricsQuery.isLoading) return <Loading />;

  if (metricsQuery.isError) {
    return (
      <Card className='dtb-metrics'>
        <CardHeader title={t('dashboard.policy.dtbMetrics.title')} />
        <CardContent>
          <Box sx={{ textAlign: 'center', py: 4 }}>
            <Typography
              color='error'
              sx={{ mb: 2 }}
            >
              {t('dashboard.policy.dtbMetrics.error')}
            </Typography>
            <Button
              variant='contained'
              startIcon={<Refresh />}
              onClick={() => metricsQuery.refetch()}
            >
              {t('dashboard.policy.dtbMetrics.retry')}
            </Button>
          </Box>
        </CardContent>
      </Card>
    );
  }

  const sortedMetrics = metricsQuery.data
    ? [...metricsQuery.data].filter((metric) => metric.draftCount > 0).sort((a, b) => b.draftCount - a.draftCount)
    : [];

  return sortedMetrics.length > 0 ? (
    <Card className='dtb-metrics lex-dashboard-card'>
      <CardHeader title={t('dashboard.policy.dtbMetrics.title')} />
      <CardContent>
        {sortedMetrics.length === 0 ? (
          <Box>Empty</Box>
        ) : (
          <Stack spacing={6}>
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: 'repeat(2, 1fr)',
                gap: 6,
              }}
            >
              {sortedMetrics.slice(0, showAll ? sortedMetrics.length : 4).map((metric) => (
                <DtbItem
                  key={metric.id}
                  metric={metric}
                />
              ))}
            </Box>
            {sortedMetrics.length > 4 && (
              <>
                {showAll ? (
                  <Button
                    className='xs'
                    variant='text'
                    size='small'
                    onClick={() => setShowAll(false)}
                  >
                    {t('dashboard.policy.dtbMetrics.showLess')} <ExpandLess />
                  </Button>
                ) : (
                  <Button
                    className='xs'
                    variant='text'
                    size='small'
                    onClick={() => setShowAll(true)}
                  >
                    {t('dashboard.policy.dtbMetrics.showMore', '', {
                      count: (sortedMetrics.length - 4).toString(),
                    })}{' '}
                    <ExpandMore />
                  </Button>
                )}
              </>
            )}
          </Stack>
        )}
      </CardContent>
    </Card>
  ) : null;
}
